// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__30ZZn","checkboxCol":"Table_checkboxCol__34QYy","emailCol":"Table_emailCol__3COaY","actionCol":"Table_actionCol__x6aZY"};